import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { PageTitle, Loading } from '../root/components/common'
import { useSelector } from 'react-redux'
import { useQuery } from 'react-query'
import { getDashboardReports } from './api/dashboard-api'
import { ReportsTable } from '../root/components/common/reports-table/reports-table'
import { useDispatch } from 'react-redux'
import { getSagasMsgs } from '../root/selectors'
import { enqueueSnackbar } from '../root/actions'
import { isEmpty } from 'lodash'
import { REPRESENTATION } from '../root/constants'
import { UserPermissions } from '../../services/permissions'

const useStyles = makeStyles(theme => ({
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 24
    },
    wrapper: {
        height: 'calc(100% - 70px)'
    },
    nameLink: {
        color: theme.textPrimary,
        textDecoration: 'none',
        fontWeight: 'bold',
        cursor: 'pointer'
    },
    actions: {
        display: 'flex',
        justifyContent: 'center'
    },
    icon: {
        color: theme.primary,
        cursor: 'pointer'
    },
    batteryWrapper: {
        display: 'flex',
        justifyContent: 'center'
    },
    statusWrapper: {
        display: 'flex',
        justifyContent: 'center'
    },
    modalButtons: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 15
    },
    modalButton: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 15
    },
    pickerWrapper: {
        marginTop: 15
    },
    fromDate: {
        marginRight: 16
    },
    input: {
        fontSize: 14,
        height: '32px',
        width: 150,
        borderRadius: '4px'
    },
    title: {
        marginBottom: 0
    },
    reportsTableWrapper: {
        height: 500
    }
}))

export default function DashboardReports() {
    const classes = useStyles()

    const dispatch = useDispatch()
    const { locale } = useSelector(state => state.main)
    const { devicesView } = useSelector(state => state.dashboard)
    const is_assigned = UserPermissions.isAllOriginalGranted()
        ? devicesView === REPRESENTATION.assigned
        : true
    const sagasMsgs = useSelector(getSagasMsgs)

    const [sorting, setSorting] = useState('')

    const { isLoading, data, isFetching } = useQuery(
        ['dashboard-reports', sorting, is_assigned],
        () =>
            getDashboardReports({
                sort_by: sorting,
                is_assigned
            }),
        {
            keepPreviousData: true,
            onError: e => {
                console.error('get dashboard report error', e)
                dispatch(
                    enqueueSnackbar({
                        message: sagasMsgs.getReportsEx,
                        options: {
                            variant: 'error'
                        }
                    })
                )
            }
        }
    )

    return (
        <div className={classes.wrapper}>
            <div className={classes.header}>
                <PageTitle
                    className={classes.title}
                    title={locale.dashboard.reports}
                />
            </div>

            {isLoading && <Loading />}

            {!isFetching && (!data || data.length === 0) && (
                <div>{locale.reports.noReportsForRange}</div>
            )}
            {!isEmpty(data) && (
                <div className={classes.reportsTableWrapper}>
                    <ReportsTable
                        isLoading={isFetching}
                        reports={data}
                        sorting={sorting}
                        onSort={setSorting}
                    />
                </div>
            )}
        </div>
    )
}
